// Content & photographs sourced from the official Government Medical College websites (see `source` on each image)
export const collegeProfiles = {
  "eluru": {
    "tagline": "Priority Nadu-Nedu college · First MBBS batch 2023-24",
    "about": [
      "Established by the Government of Andhra Pradesh under the Nadu-Nedu programme for revitalisation of healthcare services — a comprehensive initiative to upgrade 11 existing and develop 17 new Government Medical Colleges with state-of-the-art infrastructure, modern equipment and access to advanced technology, in compliance with National Medical Commission (NMC) norms.",
      "Government Medical College, Eluru is one of the five priority medical colleges identified to commence academic sessions from 2023-24, serving the Eluru district and neighbouring mandals of West Godavari region. The college is affiliated to Dr. NTR University of Health Sciences, Vijayawada and functions with the attached Government General Hospital as its teaching hospital.",
      "The campus comprises a modern academic block with lecture galleries, demonstration rooms, central library, skills laboratory, museums and dissection hall, together with hostels for students and residential quarters for faculty."
    ],
    "highlights": [
      "150 MBBS seats per year · NMC Letter of Permission",
      "Affiliated to Dr. NTR University of Health Sciences",
      "Anti-ragging, Institutional Ethics & Internal Complaints Committees constituted",
      "PwBD enabling unit for students with disabilities",
      "Competency-Based Medical Education (CBME) curriculum"
    ],
    "contact": {
      "address": "Government Medical College, Eluru, Eluru District, Andhra Pradesh",
      "email": "",
      "phone": ""
    },
    "departments": [
      "Anatomy",
      "Physiology",
      "Biochemistry",
      "Pharmacology",
      "Pathology",
      "Microbiology",
      "Forensic Medicine",
      "Community Medicine",
      "General Medicine",
      "Paediatrics",
      "Respiratory Medicine",
      "Dermatology",
      "Psychiatry",
      "General Surgery",
      "Orthopaedics",
      "Oto-Rhino-Laryngology (ENT)",
      "Ophthalmology",
      "Obstetrics & Gynaecology",
      "Anaesthesia",
      "Radio-diagnosis",
      "Dentistry"
    ],
    "gallery": [
          {
                "url": "/img/colleges/eluru/01.jpg",
                "title": "Medical College & Allied Facilities — Front Elevation",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/07/01-scaled.jpg"
          },
          {
                "url": "/img/colleges/eluru/02.jpg",
                "title": "Academic Block — Architectural View",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/07/02.jpg"
          },
          {
                "url": "/img/colleges/eluru/03.jpg",
                "title": "Hostel Towers",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/07/03-scaled.jpg"
          },
          {
                "url": "/img/colleges/eluru/04.jpg",
                "title": "Campus Panorama",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/07/04-scaled.jpg"
          },
          {
                "url": "/img/colleges/eluru/05.jpg",
                "title": "Teaching Hospital Block",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/07/05-scaled.jpg"
          },
          {
                "url": "/img/colleges/eluru/06.jpg",
                "title": "Campus Aerial View",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/08/10.jpeg"
          },
          {
                "url": "/img/colleges/eluru/07.jpg",
                "title": "Main Entrance Portico",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/08/11.jpeg"
          },
          {
                "url": "/img/colleges/eluru/08.jpg",
                "title": "Lecture Gallery Complex",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/08/12.jpeg"
          },
          {
                "url": "/img/colleges/eluru/09.jpg",
                "title": "Central Courtyard",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/08/14.jpeg"
          },
          {
                "url": "/img/colleges/eluru/10.jpg",
                "title": "Hostel & Residential Block",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/08/18.jpeg"
          },
          {
                "url": "/img/colleges/eluru/11.jpg",
                "title": "Library Block",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/08/22.jpeg"
          },
          {
                "url": "/img/colleges/eluru/12.jpg",
                "title": "Administrative Block",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/08/21.jpeg"
          },
          {
                "url": "/img/colleges/eluru/13.jpg",
                "title": "Campus Landscape",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/08/26.jpeg"
          },
          {
                "url": "/img/colleges/eluru/14.jpg",
                "title": "Hospital Approach Road",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/08/25.jpeg"
          },
          {
                "url": "/img/colleges/eluru/15.jpg",
                "title": "Students' Amenities Block",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/08/27.jpeg"
          },
          {
                "url": "/img/colleges/eluru/16.jpg",
                "title": "Academic Block — Side View",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/08/33.jpeg"
          },
          {
                "url": "/img/colleges/eluru/17.jpg",
                "title": "Skills Lab Building",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/08/30.jpeg"
          },
          {
                "url": "/img/colleges/eluru/18.jpg",
                "title": "Examination Hall",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/08/35.jpeg"
          },
          {
                "url": "/img/colleges/eluru/19.jpg",
                "title": "Faculty Quarters",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/08/WhatsApp-Image-2023-08-02-at-8.49.57-AM-3.jpeg"
          },
          {
                "url": "/img/colleges/eluru/20.jpg",
                "title": "Campus at Dusk",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/08/WhatsApp-Image-2023-08-02-at-8.49.57-AM-4.jpeg"
          },
          {
                "url": "/img/colleges/eluru/21.jpg",
                "title": "Sports Ground",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/08/WhatsApp-Image-2023-08-02-at-8.49.57-AM-5.jpeg"
          },
          {
                "url": "/img/colleges/eluru/22.jpg",
                "title": "Parking & Entrance Plaza",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/08/WhatsApp-Image-2023-08-02-at-8.49.57-AM-13.jpeg"
          },
          {
                "url": "/img/colleges/eluru/23.jpg",
                "title": "OPD Block",
                "src": "https://gmceluru-ap-gov.com/wp-content/uploads/2023/08/WhatsApp-Image-2023-08-02-at-8.49.57-AM.jpeg"
          }
    ]
  },
  "machilipatnam": {
    "tagline": "Coastal Krishna district · Teaching General Hospital",
    "about": [
      "Established by the Government of Andhra Pradesh under the Nadu-Nedu programme for revitalisation of healthcare services — a comprehensive initiative to upgrade 11 existing and develop 17 new Government Medical Colleges with state-of-the-art infrastructure, modern equipment and access to advanced technology, in compliance with National Medical Commission (NMC) norms.",
      "Government Medical College, Machilipatnam started its first MBBS batch in 2023-24 and is attached to the Government Teaching General Hospital, Machilipatnam. The institution serves the coastal population of Krishna district and offers both undergraduate (MBBS) and postgraduate programmes across pre-clinical, para-clinical and clinical departments.",
      "The college publishes fee particulars for All-India Quota, A-Category (convener), B-Category (self-financing) and C-Category (NRI) seats along with bond formats and admission checklists."
    ],
    "highlights": [
      "150 MBBS seats · PG courses commenced (2025 batch)",
      "Government Teaching General Hospital as teaching hospital",
      "Public Information Officer: M. Ravindra Kumar (Assistant Director)",
      "Detailed admission checklists for AIQ & State Quota",
      "Affiliated to Dr. NTR University of Health Sciences"
    ],
    "contact": {
      "address": "Government Medical College, Machilipatnam, Krishna District, Andhra Pradesh",
      "email": "principalgmcmachilipatnam@gmail.com",
      "phone": ""
    },
    "departments": [
      "Anatomy",
      "Physiology",
      "Biochemistry",
      "Pharmacology",
      "Pathology",
      "Microbiology",
      "Forensic Medicine",
      "Community Medicine",
      "General Medicine",
      "Paediatrics",
      "Respiratory Medicine",
      "Dermatology",
      "Psychiatry",
      "General Surgery",
      "Orthopaedics",
      "Oto-Rhino-Laryngology (ENT)",
      "Ophthalmology",
      "Obstetrics & Gynaecology",
      "Anaesthesia",
      "Radio-diagnosis",
      "Dentistry"
    ],
    "gallery": [
          {
                "url": "/img/colleges/machilipatnam/01.jpg",
                "title": "Medical College — Front Elevation",
                "src": "https://www.gmcmachilipatnam-ap-gov.com/wp-content/uploads/2023/07/09-scaled.jpg"
          },
          {
                "url": "/img/colleges/machilipatnam/02.jpg",
                "title": "Academic Block",
                "src": "https://www.gmcmachilipatnam-ap-gov.com/wp-content/uploads/2023/07/08-scaled.jpg"
          },
          {
                "url": "/img/colleges/machilipatnam/03.jpg",
                "title": "Teaching General Hospital",
                "src": "https://www.gmcmachilipatnam-ap-gov.com/wp-content/uploads/2023/07/07-scaled.jpg"
          },
          {
                "url": "/img/colleges/machilipatnam/04.jpg",
                "title": "Hostel Block",
                "src": "https://www.gmcmachilipatnam-ap-gov.com/wp-content/uploads/2023/07/06-scaled.jpg"
          },
          {
                "url": "/img/colleges/machilipatnam/05.jpg",
                "title": "Campus Panorama",
                "src": "https://www.gmcmachilipatnam-ap-gov.com/wp-content/uploads/2023/07/05-scaled.jpg"
          },
          {
                "url": "/img/colleges/machilipatnam/06.jpg",
                "title": "Lecture Gallery Complex",
                "src": "https://www.gmcmachilipatnam-ap-gov.com/wp-content/uploads/2023/07/04-scaled.jpg"
          },
          {
                "url": "/img/colleges/machilipatnam/07.jpg",
                "title": "Central Courtyard",
                "src": "https://www.gmcmachilipatnam-ap-gov.com/wp-content/uploads/2023/07/03-scaled.jpg"
          },
          {
                "url": "/img/colleges/machilipatnam/08.jpg",
                "title": "Library Block",
                "src": "https://www.gmcmachilipatnam-ap-gov.com/wp-content/uploads/2023/07/02-scaled.jpg"
          },
          {
                "url": "/img/colleges/machilipatnam/09.jpg",
                "title": "Administrative Block",
                "src": "https://www.gmcmachilipatnam-ap-gov.com/wp-content/uploads/2023/07/01-scaled.jpg"
          },
          {
                "url": "/img/colleges/machilipatnam/10.jpg",
                "title": "Campus Aerial View",
                "src": "https://www.gmcmachilipatnam-ap-gov.com/wp-content/uploads/2024/01/WhatsApp-Image-2024-01-02-at-08.40.52.jpeg"
          },
          {
                "url": "/img/colleges/machilipatnam/11.jpg",
                "title": "Hospital Approach",
                "src": "https://www.gmcmachilipatnam-ap-gov.com/wp-content/uploads/2023/07/MicrosoftTeams-image-18.jpg"
          },
          {
                "url": "/img/colleges/machilipatnam/12.jpg",
                "title": "Campus View I",
                "src": "https://www.gmcmachilipatnam-ap-gov.com/wp-content/uploads/2023/07/MicrosoftTeams-image-19.jpg"
          },
          {
                "url": "/img/colleges/machilipatnam/13.jpg",
                "title": "Campus View II",
                "src": "https://www.gmcmachilipatnam-ap-gov.com/wp-content/uploads/2023/07/MicrosoftTeams-image-20.jpg"
          },
          {
                "url": "/img/colleges/machilipatnam/14.jpg",
                "title": "Campus View III",
                "src": "https://www.gmcmachilipatnam-ap-gov.com/wp-content/uploads/2023/07/MicrosoftTeams-image-21.jpg"
          },
          {
                "url": "/img/colleges/machilipatnam/15.jpg",
                "title": "Campus View IV",
                "src": "https://www.gmcmachilipatnam-ap-gov.com/wp-content/uploads/2023/07/MicrosoftTeams-image-23.jpg"
          },
          {
                "url": "/img/colleges/machilipatnam/16.jpg",
                "title": "Campus View V",
                "src": "https://www.gmcmachilipatnam-ap-gov.com/wp-content/uploads/2023/07/MicrosoftTeams-image-26.jpg"
          }
    ]
  },
  "nandyal": {
    "tagline": "Gateway to Srisailam · Government General Hospital Nandyal",
    "about": [
      "Famous as the \"Gateway to Srisailam\", Nandyal is located in the Rayalaseema region of Andhra Pradesh, well connected by National Highway 40 (Hyderabad–Chennai) and a B-category railway station under the Guntur division. The nearest airport is Orvakal (Kurnool), 40 km away.",
      "As per G.O.Ms.No.155 dated 28-06-2022, under the Nadu-Nedu programme the Government of Andhra Pradesh decided to revitalise hospital and healthcare services across the State including strengthening of existing medical colleges and establishment of new medical colleges. Government Medical College, Nandyal at Noonepalli commenced its first MBBS batch in 2023-24.",
      "The Government General Hospital, Nandyal serves as the teaching hospital and has been maintaining birth and death records for the region since 2016."
    ],
    "highlights": [
      "150 MBBS seats · 19 teaching departments with faculty listed",
      "Government General Hospital Nandyal — 24×7 tertiary care",
      "Anti-ragging, Internal Complaints & PwBD Enabling Unit committees",
      "Affiliated to Dr. NTR University of Health Sciences",
      "Fee structure published for AIQ, A, B & C categories"
    ],
    "contact": {
      "address": "Government Medical College, Noonepalli, Nandyal – 518501, Nandyal District, Andhra Pradesh",
      "email": "Supdtgghnandyala@gmail.com",
      "phone": "+91 94912 66203"
    },
    "departments": [
      "Anatomy",
      "Physiology",
      "Biochemistry",
      "Pharmacology",
      "Pathology",
      "Microbiology",
      "Forensic Medicine",
      "Community Medicine",
      "General Medicine",
      "Paediatrics",
      "Respiratory Medicine",
      "Dermatology",
      "Psychiatry",
      "General Surgery",
      "Orthopaedics",
      "Oto-Rhino-Laryngology (ENT)",
      "Ophthalmology",
      "Obstetrics & Gynaecology",
      "Anaesthesia"
    ],
    "gallery": [
          {
                "url": "/img/colleges/nandyal/01.jpg",
                "title": "Medical College — Front Elevation",
                "src": "https://www.gmcnandyal-ap-gov.com/wp-content/uploads/2023/07/01.jpg"
          },
          {
                "url": "/img/colleges/nandyal/02.jpg",
                "title": "Academic Block",
                "src": "https://www.gmcnandyal-ap-gov.com/wp-content/uploads/2023/07/02.jpg"
          },
          {
                "url": "/img/colleges/nandyal/03.jpg",
                "title": "Government General Hospital Nandyal",
                "src": "https://www.gmcnandyal-ap-gov.com/wp-content/uploads/2023/07/03.jpg"
          },
          {
                "url": "/img/colleges/nandyal/04.jpg",
                "title": "Hostel Block",
                "src": "https://www.gmcnandyal-ap-gov.com/wp-content/uploads/2023/07/04.jpg"
          },
          {
                "url": "/img/colleges/nandyal/05.jpg",
                "title": "Campus Panorama",
                "src": "https://www.gmcnandyal-ap-gov.com/wp-content/uploads/2023/07/05.jpg"
          },
          {
                "url": "/img/colleges/nandyal/06.jpg",
                "title": "Lecture Gallery Complex",
                "src": "https://www.gmcnandyal-ap-gov.com/wp-content/uploads/2023/07/06.jpg"
          },
          {
                "url": "/img/colleges/nandyal/07.jpg",
                "title": "Central Courtyard",
                "src": "https://www.gmcnandyal-ap-gov.com/wp-content/uploads/2023/07/07.jpg"
          },
          {
                "url": "/img/colleges/nandyal/08.jpg",
                "title": "Library Block",
                "src": "https://www.gmcnandyal-ap-gov.com/wp-content/uploads/2023/07/08.jpg"
          },
          {
                "url": "/img/colleges/nandyal/09.jpg",
                "title": "Administrative Block",
                "src": "https://www.gmcnandyal-ap-gov.com/wp-content/uploads/2023/07/09.jpg"
          },
          {
                "url": "/img/colleges/nandyal/10.jpg",
                "title": "Campus Aerial View",
                "src": "https://www.gmcnandyal-ap-gov.com/wp-content/uploads/2023/07/10.jpg"
          },
          {
                "url": "/img/colleges/nandyal/11.jpg",
                "title": "Main Entrance",
                "src": "https://www.gmcnandyal-ap-gov.com/wp-content/uploads/2023/07/11.jpg"
          }
    ]
  },
  "rajamahendravaram": {
    "tagline": "Cultural capital of AP · Godavari region",
    "about": [
      "Established by the Government of Andhra Pradesh under the Nadu-Nedu programme for revitalisation of healthcare services — a comprehensive initiative to upgrade 11 existing and develop 17 new Government Medical Colleges with state-of-the-art infrastructure, modern equipment and access to advanced technology, in compliance with National Medical Commission (NMC) norms.",
      "Government Medical College, Rajamahendravaram was among the first five Nadu-Nedu colleges to begin academic sessions in 2023-24, catering to East Godavari district and the wider Godavari delta. The college is attached to the Government General Hospital, Rajamahendravaram.",
      "Institutional information including affiliation, Letter of Permission, hostel rules & regulations, fee structure and undertaking bond formats for B and C category seats are published for students and parents. Recruitment notifications for Senior Residents, paramedical staff and ICMR projects are issued periodically."
    ],
    "highlights": [
      "150 MBBS seats · Government General Hospital as teaching hospital",
      "Hostel rules & regulations and fee structure published",
      "Senior Resident, Paramedical & ICMR recruitment drives",
      "Affiliated to Dr. NTR University of Health Sciences",
      "Organisation structure & committees constituted"
    ],
    "contact": {
      "address": "Government Medical College, Rajamahendravaram, East Godavari District, Andhra Pradesh",
      "email": "",
      "phone": ""
    },
    "departments": [
      "Anatomy",
      "Physiology",
      "Biochemistry",
      "Pharmacology",
      "Pathology",
      "Microbiology",
      "Forensic Medicine",
      "Community Medicine",
      "General Medicine",
      "Paediatrics",
      "Respiratory Medicine",
      "Dermatology",
      "Psychiatry",
      "General Surgery",
      "Orthopaedics",
      "Oto-Rhino-Laryngology (ENT)",
      "Ophthalmology",
      "Obstetrics & Gynaecology",
      "Anaesthesia",
      "Radio-diagnosis",
      "Dentistry"
    ],
    "gallery": [
          {
                "url": "/img/colleges/rajamahendravaram/01.jpg",
                "title": "Medical College — Front Elevation",
                "src": "https://www.gmcrajahmahendravaram-ap-gov.com/wp-content/uploads/2023/07/02-scaled.jpg"
          },
          {
                "url": "/img/colleges/rajamahendravaram/02.jpg",
                "title": "Academic Block",
                "src": "https://www.gmcrajahmahendravaram-ap-gov.com/wp-content/uploads/2023/07/03-scaled.jpg"
          },
          {
                "url": "/img/colleges/rajamahendravaram/03.jpg",
                "title": "Government General Hospital",
                "src": "https://www.gmcrajahmahendravaram-ap-gov.com/wp-content/uploads/2023/07/01-scaled.jpg"
          },
          {
                "url": "/img/colleges/rajamahendravaram/04.jpg",
                "title": "Hostel Block",
                "src": "https://www.gmcrajahmahendravaram-ap-gov.com/wp-content/uploads/2023/07/04-scaled.jpg"
          },
          {
                "url": "/img/colleges/rajamahendravaram/05.jpg",
                "title": "Campus Panorama",
                "src": "https://www.gmcrajahmahendravaram-ap-gov.com/wp-content/uploads/2023/07/05-scaled.jpg"
          },
          {
                "url": "/img/colleges/rajamahendravaram/06.jpg",
                "title": "Main Entrance",
                "src": "https://www.gmcrajahmahendravaram-ap-gov.com/wp-content/uploads/2023/07/MicrosoftTeams-image-78.png"
          }
    ]
  },
  "vizianagaram": {
    "tagline": "North-coastal Andhra · Modern campus",
    "about": [
      "Established by the Government of Andhra Pradesh under the Nadu-Nedu programme for revitalisation of healthcare services — a comprehensive initiative to upgrade 11 existing and develop 17 new Government Medical Colleges with state-of-the-art infrastructure, modern equipment and access to advanced technology, in compliance with National Medical Commission (NMC) norms.",
      "Government Medical College, Vizianagaram commenced its first MBBS batch in 2023-24 to serve the north-coastal districts of Vizianagaram and Parvathipuram Manyam. The purpose-built campus features a multi-storey academic block, teaching hospital, hostels and staff quarters designed to NMC standards.",
      "The institution is affiliated to Dr. NTR University of Health Sciences and publishes its Letter of Permission, affiliation, admission checklist and fee structure for prospective students."
    ],
    "highlights": [
      "150 MBBS seats · Purpose-built Nadu-Nedu campus",
      "Attached teaching hospital with modern OTs & ICUs",
      "Committees & organisation structure published",
      "Affiliated to Dr. NTR University of Health Sciences",
      "Check-list and fee structure for admissions"
    ],
    "contact": {
      "address": "Government Medical College, Vizianagaram, Vizianagaram District, Andhra Pradesh",
      "email": "",
      "phone": ""
    },
    "departments": [
      "Anatomy",
      "Physiology",
      "Biochemistry",
      "Pharmacology",
      "Pathology",
      "Microbiology",
      "Forensic Medicine",
      "Community Medicine",
      "General Medicine",
      "Paediatrics",
      "Respiratory Medicine",
      "Dermatology",
      "Psychiatry",
      "General Surgery",
      "Orthopaedics",
      "Oto-Rhino-Laryngology (ENT)",
      "Ophthalmology",
      "Obstetrics & Gynaecology",
      "Anaesthesia",
      "Radio-diagnosis",
      "Dentistry"
    ],
    "gallery": [
          {
                "url": "/img/colleges/vizianagaram/01.jpg",
                "title": "Medical College — Front Elevation",
                "src": "https://www.gmcvizianagaram-ap-gov.com/wp-content/themes/custom-theme/assets/images/001_Vizianagaram_MC_Views/01-min.jpg"
          },
          {
                "url": "/img/colleges/vizianagaram/02.jpg",
                "title": "Academic Block",
                "src": "https://www.gmcvizianagaram-ap-gov.com/wp-content/themes/custom-theme/assets/images/001_Vizianagaram_MC_Views/02-min.jpg"
          },
          {
                "url": "/img/colleges/vizianagaram/03.jpg",
                "title": "Teaching Hospital",
                "src": "https://www.gmcvizianagaram-ap-gov.com/wp-content/themes/custom-theme/assets/images/001_Vizianagaram_MC_Views/03-min.jpg"
          },
          {
                "url": "/img/colleges/vizianagaram/04.jpg",
                "title": "Hostel Block",
                "src": "https://www.gmcvizianagaram-ap-gov.com/wp-content/themes/custom-theme/assets/images/001_Vizianagaram_MC_Views/04-min.jpg"
          },
          {
                "url": "/img/colleges/vizianagaram/05.jpg",
                "title": "Campus Panorama",
                "src": "https://www.gmcvizianagaram-ap-gov.com/wp-content/themes/custom-theme/assets/images/001_Vizianagaram_MC_Views/05-min.jpg"
          },
          {
                "url": "/img/colleges/vizianagaram/06.jpg",
                "title": "Lecture Gallery Complex",
                "src": "https://www.gmcvizianagaram-ap-gov.com/wp-content/themes/custom-theme/assets/images/001_Vizianagaram_MC_Views/06-min.jpg"
          },
          {
                "url": "/img/colleges/vizianagaram/07.jpg",
                "title": "Central Courtyard",
                "src": "https://www.gmcvizianagaram-ap-gov.com/wp-content/themes/custom-theme/assets/images/001_Vizianagaram_MC_Views/07-min.jpg"
          }
    ]
  },
  "paderu": {
    "tagline": "First Government Medical College in the tribal area of Paderu",
    "about": [
      "Government Medical College Paderu is situated in a broad picturesque landscape falling under the high-altitude agro-climatic zone, with rich flora and fauna and lush green valleys at over 900 metres above mean sea level, surrounded by the Eastern Ghats — about 110–114 km from Visakhapatnam.",
      "It is the first Government Medical College in the tribal area of Alluri Sitharama Raju district, bringing quality medical education and healthcare to one of the most underserved regions of the State. The college is affiliated to Dr. NTR University of Health Sciences, Vijayawada, and works with the Government General Hospital (GGH), Paderu.",
      "Inspired by the legacy of Andhra Medical College, the institution focuses on community-centred medicine, tribal healthcare initiatives and research on indigenous health challenges, integrating modern medical knowledge with early clinical exposure and a strong emphasis on public health and primary care."
    ],
    "highlights": [
      "Principal (FAC): Dr. P. Venkateswarlu, MBBS, MD (Microbiology)",
      "Superintendent GGH (FAC): Dr. Kolipakula Srinivasa Rao, MS",
      "MBBS admissions 2026-27 conducted at the ground floor of the college",
      "Tribal healthcare & community-oriented curriculum",
      "Affiliated to Dr. NTR University of Health Sciences"
    ],
    "contact": {
      "address": "Government Medical College, Paderu, Alluri Sitharama Raju District, Andhra Pradesh",
      "email": "",
      "phone": ""
    },
    "departments": [
      "Anatomy",
      "Physiology",
      "Biochemistry",
      "Pharmacology",
      "Pathology",
      "Microbiology",
      "Forensic Medicine",
      "Community Medicine",
      "General Medicine",
      "Paediatrics",
      "Respiratory Medicine",
      "Dermatology",
      "Psychiatry",
      "General Surgery",
      "Orthopaedics",
      "Oto-Rhino-Laryngology (ENT)",
      "Ophthalmology",
      "Obstetrics & Gynaecology",
      "Anaesthesia",
      "Radio-diagnosis",
      "Dentistry"
    ],
    "gallery": [
          {
                "url": "/img/colleges/paderu/01.jpg",
                "title": "Government Medical College, Paderu — Building",
                "src": "https://gmcpaderu.com/admin/upload/284615-untitled-design-23.jpg"
          },
          {
                "url": "/img/colleges/paderu/02.jpg",
                "title": "Eastern Ghats — Way to Paderu",
                "src": "https://gmcpaderu.com/admin/upload/View_in_the_way_to_Paderu.jpg"
          }
    ]
  },
  "piduguralla": {
    "tagline": "47-acre campus · Palnadu district",
    "about": [
      "Government Medical College, Piduguralla is a premier institution established to transform the healthcare and medical education landscape of Palnadu district. Spread across a sprawling 47-acre campus and developed under a centrally sponsored scheme, it integrates academic excellence with accessible, state-of-the-art public healthcare for over eight lakh citizens across the Palnadu region.",
      "The campus features specialised medical college buildings, highly advanced laboratories, a dedicated nursing college and modern residential hostels for students and faculty. The multi-block teaching hospital is equipped with modern operation theatres and a 24×7 Outpatient Department.",
      "Vision: to emerge as a premier Government Medical College dedicated to excellence in medical education, patient care, research and community service — providing equitable, affordable and quality healthcare to the rural and underserved populations of Palnadu and adjoining regions of Andhra Pradesh and Telangana."
    ],
    "highlights": [
      "100 MBBS seats from 2026-27 (NMC approval)",
      "47-acre campus with dedicated nursing college",
      "Multi-block teaching hospital · 24×7 OPD",
      "Competency-based medical education & mentorship programme",
      "Student support, patient portal & emergency contact services"
    ],
    "contact": {
      "address": "Government Medical College, Piduguralla, Palnadu District, Andhra Pradesh",
      "email": "",
      "phone": "+91 77022 41364"
    },
    "departments": [
      "Anatomy",
      "Physiology",
      "Biochemistry",
      "Pharmacology",
      "Pathology",
      "Microbiology",
      "Forensic Medicine",
      "Community Medicine",
      "General Medicine",
      "Paediatrics",
      "Respiratory Medicine",
      "Dermatology",
      "Psychiatry",
      "General Surgery",
      "Orthopaedics",
      "Oto-Rhino-Laryngology (ENT)",
      "Ophthalmology",
      "Obstetrics & Gynaecology",
      "Anaesthesia",
      "Radio-diagnosis",
      "Dentistry"
    ],
    "gallery": [
          {
                "url": "/img/colleges/piduguralla/gate.jpg",
                "title": "Government Medical College and Hospital, Piduguralla — Entrance",
                "src": "/img/colleges/piduguralla/gate.jpg"
          },
          {
                "url": "/img/colleges/piduguralla/01.jpg",
                "title": "Medical College — Campus View",
                "src": "https://gmcpiduguralla.org/wp-content/uploads/2026/07/WhatsApp-Image-2026-07-20-at-09.50.49.jpeg"
          },
          {
                "url": "/img/colleges/piduguralla/03.jpg",
                "title": "Teaching Hospital",
                "src": "https://gmcpiduguralla.org/wp-content/uploads/2026/08/WhatsApp-Image-2026-07-20-at-12.08.14.jpeg"
          },
          {
                "url": "/img/colleges/piduguralla/04.jpg",
                "title": "Laboratory Block",
                "src": "https://gmcpiduguralla.org/wp-content/uploads/2026/08/WhatsApp-Image-2026-07-18-at-16.50.17.jpeg"
          },
          {
                "url": "/img/colleges/piduguralla/05.jpg",
                "title": "Hostel Block",
                "src": "https://gmcpiduguralla.org/wp-content/uploads/2026/07/WhatsApp-Image-2026-07-09-at-10.04.35.jpeg"
          },
          {
                "url": "/img/colleges/piduguralla/06.jpg",
                "title": "Biochemistry Laboratory",
                "src": "https://gmcpiduguralla.org/wp-content/uploads/2026/07/Biochemistry.jpg.jpeg"
          },
          {
                "url": "/img/colleges/piduguralla/07.jpg",
                "title": "Lecture Hall",
                "src": "https://gmcpiduguralla.org/wp-content/uploads/2026/07/WhatsApp-Image-2026-07-13-at-16.28.34.jpeg"
          },
          {
                "url": "/img/colleges/piduguralla/08.jpg",
                "title": "Community Medicine Department",
                "src": "https://gmcpiduguralla.org/wp-content/uploads/2026/07/Community-Medicine.jpg.jpeg"
          }
    ]
  }
};
